import * as React from 'react';

import {useQuery, useApolloClient} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetEdition as GetEditionQuery,
    GetEditionVariables as GetEditionQueryVariables,
    EditionFragment as Edition,
    EditionStubFragment as EditionStub,
} from 'nutshell-graphql-types';

import EDITION_STUB_FRAGMENT from '../graphql/fragments/edition-stub-fragment.graphql';
import GET_EDITION from '../graphql/queries/get-edition.graphql';

type Props = {
    editionId: string;
    children: (arg1: {
        edition: Edition | null | undefined;
        editionStub: EditionStub | null | undefined;
        isLoading: boolean;
        error: string | null | undefined;
    }) => React.ReactElement;
};

export function EditionQuery(props: Props) {
    const client = useApolloClient();
    let editionStub: EditionStub | null | undefined;

    try {
        editionStub = client.readFragment({
            id: props.editionId,
            fragmentName: 'EditionStubFragment',
            fragment: EDITION_STUB_FRAGMENT,
        });
    } catch {
        // Error
    }

    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetEditionQuery, GetEditionQueryVariables>(GET_EDITION, {
        variables: {editionId: props.editionId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    const edition = data ? data.edition : null;

    return props.children({
        edition: edition && edition.__typename === 'Edition' ? edition : null,
        editionStub,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    });
}
